import React, { useState, useEffect } from 'react'
import Skeletons from '@/custom/components/Skeletons'
import './Loader.css'

function BannerSkeletons() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <div className="bannerSkeletonWrapper">
            <div className="bannerSkeletonInner">
                {!isMobile ? (
                    <img src="assets/images/desktop-placeholder.svg" alt="web_banner_loader" />
                ) : (
                    <img src="assets/images/mobile-placeholder.svg" alt="mobile_banner_loader" />
                )}
            </div>
        </div>
    )
}

export default BannerSkeletons
